import { render, staticRenderFns } from "./ProductsListTemplate.vue?vue&type=template&id=11f7a3ed&scoped=true&"
import script from "./ProductsListTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductsListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListTemplate.vue?vue&type=style&index=0&id=11f7a3ed&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7a3ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCard: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/ProductCard.vue').default})
